export enum EquipmentInputsSettings {
  MAX_EQUIPMENT_INPUT = 25,
}
